// extracted by mini-css-extract-plugin
module.exports = {"mbNormal":"pages-module--mb-normal--2DnjT"};